import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=6f6e7790&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=6f6e7790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e7790",
  null
  
)

export default component.exports